import React from 'react';
import { Check } from 'lucide-react';
import { Button } from '@/components/ui/button';

export function RegistrationSuccess({ message, onAnother }) {
  return (
    <div className="max-w-md text-center bg-white border border-slate-200 rounded-2xl shadow-sm p-8" data-testid="public-registration-success">
      <div className="w-14 h-14 rounded-full bg-emerald-50 text-emerald-600 flex items-center justify-center mx-auto mb-4">
        <Check className="h-7 w-7" />
      </div>
      <h1 className="text-2xl font-semibold text-slate-900 mb-2">Fast geschafft!</h1>
      <p className="text-slate-600">{message}</p>
      <Button
        type="button"
        className="mt-6"
        onClick={onAnother}
        data-testid="public-registration-another-btn"
      >
        Weitere Anmeldung vornehmen
      </Button>
      <p className="text-sm text-slate-500 mt-3">
        Kontaktdaten und der Zahlungspflichtige bleiben erhalten. Den Teilnehmer können Sie anpassen, zum Beispiel für ein Geschwisterkind.
      </p>
    </div>
  );
}
